import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import CompanyUser from "api/CompanyUser";

import CompanyUserModel from 'models/CompanyUser';
import PaginationModel from 'models/Pagination';
import Collection from 'models/Collection';

import {
  LOGIN_SUCCESS,
  LOGOUT,
	HIDE_MODAL,
	MESSAGE_INFO,
	MESSAGE_SUCCES
} from "actions/types";
import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";

import {Overview as CompanyUserOverview} from 'views/companyuser/Overview';

class CompanyUserOverviewController extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {error: null,isLoaded: false,items: [], pagination: new PaginationModel()};
		//navigate('/', { replace: true })
	}
	
	componentDidMount() {
		this.getData();
	}

	removeUser =async(data) => {
		const { pagination } = this.state;
		const {companyid, dispatch} = this.props;
		try {
			dispatch(showLoader());
			var response = await CompanyUser.removeUserFromCompany(companyid, data.id);
			dispatch({type: HIDE_MODAL});
			dispatch({ type: MESSAGE_SUCCES, "message": "Gebruiker is met succes ontkoppeld", "header": "Ontkoppeling bedrijf" });

				pagination.addData(response.data.companyUsers);
			this.setState({
				isLoaded: true,
				items: (new Collection()).addData(response.data.companyUsers, new CompanyUserModel() )
			});
			dispatch(hideLoader());						
		} catch(error) {
			console.log( " error ", error );
			dispatch(hideLoader());
		}			
		/*
		let response = await api.setProductState(data);
		const { dispatch } = this.props;
		if(response.status == 200) {
			dispatch({type: HIDE_MODAL});
			dispatch({ type: MESSAGE_SUCCES, "message": "Nieuwe productstatus is opgeslagen", "header": "Product status wijziging" });
			this.getData();
		}
		*/
	}

	mobileBackButtonHandler= (event) => {
		const {navigate, companyid } = this.props;
		navigate('/company');
	}
			
	getData = (page = 0) => {
		const { pagination } = this.state;
		const {companyid, dispatch} = this.props;
				let mobileButton = (
					<>
					<a href="#" onClick={this.mobileBackButtonHandler} className="back btn-circle">
						<svg xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24">
							<path d="M17.921,1.505a1.5,1.5,0,0,1-.44,1.06L9.809,10.237a2.5,2.5,0,0,0,0,3.536l7.662,7.662a1.5,1.5,0,0,1-2.121,2.121L7.688,15.9a5.506,5.506,0,0,1,0-7.779L15.36.444a1.5,1.5,0,0,1,2.561,1.061Z"></path>
						</svg>
					</a>
					</>
);
				
				dispatch(showLoader(true, mobileButton));
		CompanyUser.get(companyid, page)
			.then((response) =>   {
				pagination.addData(response.data);
			this.setState({
				isLoaded: true,
				items: (new Collection()).addData(response.data, new CompanyUserModel() )
			});
			dispatch(hideLoader());
		})
		.catch(() => {
			dispatch(hideLoader());
		});
	}

	render() {
	const { items, pagination } = this.state;
	const {companyid} = this.props;
	return <CompanyUserOverview companyid={companyid} items={items} pagingEventHandler={this.getData} pagination={pagination} removeUserEvent={this.removeUser} />;
	}

}

const CompanyUserOverviewInit = (props) => {
	let { companyid } = useParams();
	let navigate = useNavigate();
	return (<CompanyUserOverviewController {...props} companyid={companyid} navigate={navigate}/>)
}

function mapStateToProps(state) {
  const { isLoggedIn } = state.auth;
  return {
    isLoggedIn,
  };
}

export default connect(mapStateToProps)(CompanyUserOverviewInit);